import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-9a3hu3-0"
})(["display:block;"]);
export var Content = styled.div.withConfig({
  displayName: "Inner__Content",
  componentId: "sc-9a3hu3-1"
})(["display:block;position:relative;overflow:hidden;"]);